/* Builds accordions from a `details` richtext: a paragraph that is entirely
   bold starts a new dropdown; the nodes after it become that dropdown's body. */
if (!customElements.get('multirow-accordion')) {
  let multirowPanelId = 0;

  class MultirowAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.built) return;
      this.dataset.built = 'true';
      this.iconTemplate = this.closest('.multirow-section')?.querySelector('.multirow-section__icon-template');
      this.build();
    }

    build() {
      const items = [];
      Array.from(this.children).forEach((node) => {
        if (this.isHeading(node)) {
          items.push({ title: node.textContent.trim(), body: [] });
        } else if (items.length) {
          items[items.length - 1].body.push(node);
        }
      });
      if (!items.length) return; // no bold heading line: leave the richtext as-is

      this.textContent = '';
      items.forEach((item, index) => this.append(this.buildItem(item, index === 0)));
    }

    isHeading(node) {
      if (node.tagName !== 'P') return false;
      const bold = node.querySelector('strong, b');
      const text = node.textContent.trim();
      return Boolean(bold) && text !== '' && text === bold.textContent.trim();
    }

    buildItem({ title, body }, open) {
      multirowPanelId += 1;
      const panelId = `MultirowPanel-${multirowPanelId}`;

      const item = document.createElement('div');
      item.className = 'multirow-section__item';

      const heading = document.createElement('h3');
      heading.className = 'multirow-section__item-heading';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'multirow-section__trigger';
      trigger.setAttribute('aria-controls', panelId);

      const label = document.createElement('span');
      label.textContent = title;
      trigger.append(label);
      if (this.iconTemplate) trigger.append(this.iconTemplate.content.cloneNode(true));
      trigger.addEventListener('click', () => {
        this.setOpen(item, trigger, trigger.getAttribute('aria-expanded') !== 'true');
      });

      const panel = document.createElement('div');
      panel.className = 'multirow-section__panel';
      panel.id = panelId;

      const inner = document.createElement('div');
      inner.className = 'multirow-section__panel-inner';
      inner.append(...body);
      panel.append(inner);

      heading.append(trigger);
      item.append(heading, panel);
      this.setOpen(item, trigger, open);
      return item;
    }

    setOpen(item, trigger, open) {
      this.preventStickyHeaderReveal();
      if (open) {
        // one dropdown open at a time
        this.querySelectorAll('.multirow-section__item.is-open').forEach((other) => {
          if (other === item) return;
          other.classList.remove('is-open');
          other.querySelector('.multirow-section__trigger').setAttribute('aria-expanded', 'false');
        });
      }
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
    }

    preventStickyHeaderReveal() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
  }

  customElements.define('multirow-accordion', MultirowAccordion);
}
